import ButtonBack from '@/view/components/ButtonBack'
import { Skeleton } from '@/view/components/ui/skeleton'
import Container from './Container'

const RaffleDetailSkeleton = () => {
  return (
    <div className="flex flex-col items-center">
      <Container>
        <ButtonBack label="Sorteios ativos" className="mb-0" />
        <div className="flex flex-col items-center gap-8">
          <div className="grid w-full grid-cols-3 gap-5">
            <Skeleton className="col-span-1 h-[451px] rounded-3xl" />
            <div className="col-span-2 rounded-3xl border p-5">
              <Skeleton className="mb-2 h-6 w-1/2" />
              <Skeleton className="mb-4 h-4 w-full" />
              <Skeleton className="h-4 w-full" />
            </div>
          </div>
          <div className="flex w-full flex-col gap-5 rounded-2xl border p-5">
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-10 w-full" />
          </div>

          <div className="flex w-full flex-col gap-4">
            <h2 className="text-2xl font-semibold">Prêmios</h2>
            <ul className="w-full rounded-2xl border p-5">
              {Array.from({ length: 3 }).map((_, index) => (
                <li key={index} className="mb-4 w-full rounded-xl border p-5">
                  <div className="flex items-center gap-4">
                    <Skeleton className="h-6 w-16 rounded-full" />
                    <Skeleton className="h-6 w-1/2" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default RaffleDetailSkeleton
